
import { cn } from '@/lib/utils';

/** Thin brand progress bar (muted track, medlux fill). `value` is 0-100 and is
    clamped — callers pass the raw percentage, not a width style.
    `tone="onDark"` is the coral-on-green variant for bg-medlux-strong panels. */
export function ProgressBar({
  value,
  tone = 'default',
  label,
  className,
}: {
  value: number;
  tone?: 'default' | 'onDark';
  /** Announces the bar to screen readers. Omit when a visible sentence next to it
   *  already states the progress — the bar then stays decorative instead of
   *  repeating the same fact twice. */
  label?: string;
  className?: string;
}) {
  const pct = Math.min(100, Math.max(0, value));
  return (
    <div
      {...(label
        ? { role: 'progressbar', 'aria-label': label, 'aria-valuenow': pct, 'aria-valuemin': 0, 'aria-valuemax': 100 }
        : { 'aria-hidden': true })}
      className={cn(
        'h-1.5 w-full overflow-hidden rounded-full',
        tone === 'onDark' ? 'bg-white/15' : 'bg-muted',
        className,
      )}
    >
      <div
        className={cn(
          'h-full rounded-full transition-[width] duration-300 motion-reduce:transition-none',
          tone === 'onDark' ? 'bg-highlight-soft' : 'bg-medlux',
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
